import React, { useCallback } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'

// components
import { Title2 } from 'components/Titles'
import { Paragraph1 } from 'components/Paragraphs'
import Institute from './icons/Institute'
import Curriculum from './icons/Curriculum'
import Teacher from './icons/Teacher'

const Container = styled.div(({ theme }) => css`
  color: ${theme.blueElectric};
  padding: 50px 40px 50px 30px;
  display: flex;
  justify-content: center;
`)

const PresetContainer = styled.div(({ theme }) => css`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: inset 0px 0px 0px 1px ${theme.separator};
  padding: 70px 40px 60px 40px;
  margin: 10px;
  border-radius: 5px;
  flex: 1 1 0px;
  max-width: 380px;
  transition: box-shadow 100ms ease;
  text-align: center;
  :hover {
    box-shadow: inset 0px 0px 0px 2px ${theme.blueElectric};
  }
`)

const IconContainer = styled.div`
  height: 130px;
`
const Title = styled(Title2)(({ theme }) => css`
  color: ${theme.blueElectric};
  margin-bottom: 30px;
`)
const Description = styled(Paragraph1)(({ theme }) => css`
  color: ${theme.blueUltraDark};
  margin-bottom: 40px;
`)
const Button = styled.div(({ theme }) => css`
  color: ${theme.blueElectric};
  font-weight: 700;
`)

const presets = [
  {
    icon: Institute,
    url: '/gr3?color=ratio_attempt_correct&population=all&showRelations=true'
  },
  {
    icon: Curriculum,
    url: '/un53?color=average_attempts_per_question&population=all&showRelations=true'
  },
  {
    icon: Teacher,
    url: '/tp1789?color=average_mastery&population=USV2000006&showRelations=true'
  }
]

const Preset = ({ preset, setPresets, index }) => {
  const onClick = useCallback(() => {
    setPresets(preset.url)
  }, [setPresets, preset.url])

  return (
    <PresetContainer key={index} onClick={onClick}>
      <div>
        <IconContainer>
          <preset.icon />
        </IconContainer>
        <Title>
          <FormattedMessage id={`preset-${index}-title`} />
        </Title>
        <Description>
          <FormattedMessage id={`preset-${index}-description`} />
        </Description>
      </div>
      <Button>
        <FormattedMessage id={`preset-${index}-button`} />
      </Button>
    </PresetContainer>
  )
}

const MenuContent = ({ closeMenu }) => {
  const history = useHistory()

  const setPresets = useCallback((url) => {
    history.push(`${url}`)
    closeMenu()
  }, [history, closeMenu])

  return (
    <Container>
      {
        presets.map((preset, index) => {
          return <Preset key={index} preset={preset} setPresets={setPresets} index={index} />
        })
      }
    </Container>
  )
}

export default MenuContent
